import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({
    gfm: true,
    breaks: true,
    headerIds: false,
    mangle: false,
    tables: true,
    smartLists: true,
    smartypants: true,
    highlight: function(code, language) {
        return code;
    }
});

// Allow safe inline styles on table/code elements for formatting
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    const STYLE_NODES = ['TABLE', 'TH', 'TD', 'SPAN', 'DIV', 'CODE'];

    if (STYLE_NODES.includes(node.nodeName) && node.hasAttribute('style')) {
        const ALLOWED_PROPERTIES = [
            'color:', 'background-color:', 'text-align:', 'font-weight:', 'font-style:'
        ];

        const safeStyles = node.getAttribute('style')
            .split(';')
            .filter(style => ALLOWED_PROPERTIES.some(prop => style.trim().startsWith(prop)))
            .join(';');

        if (safeStyles) {
            node.setAttribute('style', safeStyles);
        } else {
            node.removeAttribute('style');
        }
    }
});

export const renderMarkdown = (text) => {
    if (!text) return { __html: '' };

    const rawMarkup = marked(text);
    const sanitisedMarkup = DOMPurify.sanitize(rawMarkup, {
        ADD_ATTR: ['target', 'rel'],
        ADD_TAGS: ['iframe'],
        FORBID_TAGS: ['style', 'script'],
        FORBID_ATTR: ['onerror', 'onload', 'onclick']
    });

    return { __html: sanitisedMarkup };
};

export const enhanceTableMarkup = (html) => {
    return html
        .replace(/<table>/g, '<div class="table-responsive"><table class="markdown-table">')
        .replace(/<\/table>/g, '</table></div>');
};
